var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewEvolution',{key:_vm.evolution.id,attrs:{"title":_vm.evolution.name,"type":_vm.evolution.type,"target":_vm.evolution.target,"resident_id":_vm.resident_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }